import {
  LOG_IN_MODAL_OPENED,
  LOG_IN_MODAL_CLOSED,
  ONBOARDING_MODAL_OPENED,
  ONBOARDING_MODAL_CLOSED,
  SEARCH_MODAL_OPENED,
  SEARCH_MODAL_CLOSED,
  SIGN_UP_MODAL_OPENED,
  SIGN_UP_MODAL_CLOSED,
  FAVORITE_MODAL_OPENED,
  FAVORITE_MODAL_CLOSED,
  CARD_FILTER_MODAL_OPENED,
  CARD_FILTER_MODAL_CLOSED,
  FLYER_FILTER_MODAL_OPENED,
  FLYER_FILTER_MODAL_CLOSED,
  FLYER_PRICING_MODAL_OPENED,
  FLYER_PRICING_MODAL_CLOSED,
  FORGOT_PASSWORD_MODAL_OPENED,
  FORGOT_PASSWORD_MODAL_CLOSED,
  COIN_PRODUCTS_MODAL_OPENED,
  COIN_PRODUCTS_MODAL_CLOSED,
  EVENT_PRICING_MODAL_OPENED,
  EVENT_PRICING_MODAL_CLOSED,
  NOTIFICATIONS_MODAL_OPENED,
  NOTIFICATIONS_MODAL_CLOSED,
  CURRENCY_MODAL_OPENED,
  CURRENCY_MODAL_CLOSED,
  COMPARISON_MODAL_OPENED,
  COMPARISON_MODAL_CLOSED,
  PREVIEW_MODAL_OPENED,
  PREVIEW_MODAL_CLOSED,
  trackModalOpen,
  trackModalClosed,
} from '../redux/modals';

import { ACCOUNT_DRAWER_CLOSED, ACCOUNT_DRAWER_OPENED } from '../redux/account';

import { SHARE_DRAWER_OPENED, SHARE_DRAWER_CLOSED } from '../redux/singleCard';

import { NAV_OPENED, NAV_CLOSED } from '../redux/nav';

export default function modalsTrackingEpic(
  action$: ActionObs,
  store: Store,
): Obs {
  return action$
    .ofType(
      LOG_IN_MODAL_OPENED,
      LOG_IN_MODAL_CLOSED,
      ONBOARDING_MODAL_OPENED,
      ONBOARDING_MODAL_CLOSED,
      SEARCH_MODAL_OPENED,
      SEARCH_MODAL_CLOSED,
      SIGN_UP_MODAL_OPENED,
      SIGN_UP_MODAL_CLOSED,
      FAVORITE_MODAL_OPENED,
      FAVORITE_MODAL_CLOSED,
      CARD_FILTER_MODAL_OPENED,
      CARD_FILTER_MODAL_CLOSED,
      FLYER_FILTER_MODAL_OPENED,
      FLYER_FILTER_MODAL_CLOSED,
      FLYER_PRICING_MODAL_OPENED,
      FLYER_PRICING_MODAL_CLOSED,
      FORGOT_PASSWORD_MODAL_OPENED,
      FORGOT_PASSWORD_MODAL_CLOSED,
      COIN_PRODUCTS_MODAL_OPENED,
      COIN_PRODUCTS_MODAL_CLOSED,
      EVENT_PRICING_MODAL_OPENED,
      EVENT_PRICING_MODAL_CLOSED,
      ACCOUNT_DRAWER_CLOSED,
      ACCOUNT_DRAWER_OPENED,
      SHARE_DRAWER_OPENED,
      SHARE_DRAWER_CLOSED,
      NOTIFICATIONS_MODAL_OPENED,
      NOTIFICATIONS_MODAL_CLOSED,
      CURRENCY_MODAL_OPENED,
      CURRENCY_MODAL_CLOSED,
      COMPARISON_MODAL_OPENED,
      COMPARISON_MODAL_CLOSED,
      PREVIEW_MODAL_OPENED,
      PREVIEW_MODAL_CLOSED,
      NAV_OPENED,
      NAV_CLOSED,
    )
    .map(({ type }) => {
      let id;

      switch (type) {
        case LOG_IN_MODAL_OPENED:
        case LOG_IN_MODAL_CLOSED:
          id = 'logIn';
          break;
        case ONBOARDING_MODAL_OPENED:
        case ONBOARDING_MODAL_CLOSED:
          id = 'onboarding';
          break;
        case SEARCH_MODAL_OPENED:
        case SEARCH_MODAL_CLOSED:
          id = 'search';
          break;
        case SIGN_UP_MODAL_OPENED:
        case SIGN_UP_MODAL_CLOSED:
          id = 'signUp';
          break;
        case FLYER_PRICING_MODAL_OPENED:
        case FLYER_PRICING_MODAL_CLOSED:
          id = 'flyerPricing';
          break;
        case FAVORITE_MODAL_OPENED:
        case FAVORITE_MODAL_CLOSED:
          id = 'favorite';
          break;
        case CARD_FILTER_MODAL_OPENED:
        case CARD_FILTER_MODAL_CLOSED:
          id = 'filter';
          break;
        case FLYER_FILTER_MODAL_OPENED:
        case FLYER_FILTER_MODAL_CLOSED:
          id = 'flyerFilter';
          break;
        case FORGOT_PASSWORD_MODAL_OPENED:
        case FORGOT_PASSWORD_MODAL_CLOSED:
          id = 'forgotPassword';
          break;
        case COIN_PRODUCTS_MODAL_OPENED:
        case COIN_PRODUCTS_MODAL_CLOSED:
          id = 'coinProducts';
          break;
        case ACCOUNT_DRAWER_CLOSED:
        case ACCOUNT_DRAWER_OPENED:
          id = 'accountDrawer';
          break;
        case SHARE_DRAWER_OPENED:
        case SHARE_DRAWER_CLOSED:
          id = 'pdpShareDrawer';
          break;
        case NAV_OPENED:
        case NAV_CLOSED:
          id = 'nav';
          break;
        case NOTIFICATIONS_MODAL_OPENED:
        case NOTIFICATIONS_MODAL_CLOSED:
          id = 'notifications';
          break;
        case CURRENCY_MODAL_OPENED:
        case CURRENCY_MODAL_CLOSED:
          id = 'currency';
          break;
        case COMPARISON_MODAL_OPENED:
        case COMPARISON_MODAL_CLOSED:
          id = 'comparison';
          break;
        case PREVIEW_MODAL_OPENED:
        case PREVIEW_MODAL_CLOSED:
          id = 'preview';
          break;
        default:
          id = 'default';
          break;
      }
      let actionType =
        type.indexOf('OPENED') >= 0 ? trackModalOpen : trackModalClosed;

      return actionType(id);
    });
}
